import { CourseType } from "../../../types/Course";
import { PagedRequestType, PagedResultsType } from "../../../types/PagedResults";
import { StudentType } from "../../../types/Student";
import { get, postBlob } from "../../../utils/axios-config";
import { COURSES, STUDENT_CERTIFICATE_DOWNLOAD, STUDENT_CERTIFICATES, STUDENTS } from "../../../utils/constants";

export const getStudentByCode = async (code?: string) => {
 
    return await get<StudentType>(`${STUDENTS}/${code}`)
};
export const getStudentCoursesByStudentId = async (id: string) => {
 
    return await get<CourseType[]>(`${STUDENTS}/${id}${COURSES}`)
};
export const getStudentById = async (id?: string) => {
 
    return await get<StudentType>(`${STUDENTS}/id/${id}`)
};

export const getStudentCertificate = async (data:any) => {
      return await postBlob<any>(STUDENT_CERTIFICATE_DOWNLOAD, data);
};
export const getStudentsCertificates = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdStudent ? { IdStudent: data.IdStudent } : {}),
        ...(data?.SearchTerm ? { SearchTerm: data.SearchTerm } : {}),

    });
    const url = `${STUDENT_CERTIFICATES}?${queryParams.toString()}`;
    return await get<PagedResultsType<any>>(url)
};